enum SummaryOperationTypes {
  None = 0,
  Count = 1,
  Average = 2,
};

export default SummaryOperationTypes;